import * as React from 'react'
import styled from 'styled-components'

import { Props, State } from './types'

const StyledInputMetter = styled.div`
  display: flex;
  align-items: center;
  margin: 5px 0 15px;
`

const StyledInputMetterItem = styled.div`
  width: 20%;
  height: 5px;
  border-radius: 5px;
  border: none;
  margin-right: 19px;
  &:last-child {
    margin-right: 0;
  }
  &.first {
    background: red;
  }
  &.second {
    background: orange;
  }
  &.third {
    background: green;
  }
  &.fouth {
    background: #00B779;
  }
  &.nothing {
    background: #E6EAEE;
  }
`
class TextInputMetter extends React.Component<Props, State> {
  state: State = {
    color: 'first',
  }

  /**
   * Check the strengh of the password
   * @param val
   */
  strenghPassword = (val: string): number => {
    let result = 0

    // If password is null, undefined, '' or false
    if (!val || val === '' || val.length === 0) {
      return (result = 0)
    }

    // If password is less or equal than 4
    if (val.length <= 4) {
      return (result = 1)
    }

    // If password is greater than 4
    if (val.length > 4) {
      result = 2
    }

    // If password has number
    const r = /[0-9]/g
    if (val.match(r)) {
      result += 1
    }

    // If password has special string
    const regex = /[!@#\$%\^\&*\)\(+=._-]+$/g
    if (val.match(regex)) {
      result += 1
    }

    if (result > 4) {
      result = 4
    }

    return result
  }

  /**
   * Change the color of the meter
   * according to the strengh
   * @return {string}
   */
  changeColor = () => {
    switch (this.strenghPassword(this.props.value)) {
      case 1:
        return 'first'
      case 2:
        return 'second'
      case 3:
        return 'third'
      case 4:
        return 'fouth'
      default:
        return 'nothing'
    }
  }

  /**
   * At each keystroke display the metter
   * according to the strengh
   * @return {JSX.Element[]} - A item that represents the strengh
   */
  displayTextInputMetter = () => {
    const a: JSX.Element[] = []
    const strengh = this.strenghPassword(this.props.value)
    if (strengh === 0) {
      for (let i = 0; i < 4; i++) {
        a.push(
          <StyledInputMetterItem key={i} className="nothing">
            {null}
          </StyledInputMetterItem>,
        )
      }
      return a
    }

    for (let i = 0; i < strengh; i++) {
      a.push(
        <StyledInputMetterItem key={i} className={`${this.changeColor()}`}>
          {null}
        </StyledInputMetterItem>,
      )
    }

    for (let i = strengh; i < 4; i++) {
      a.push(
        <StyledInputMetterItem key={i} className="nothing">
          {null}
        </StyledInputMetterItem>,
      )
    }
    return a
  }

  /**
   * Display the main content
   */
  render() {
    return (
      <StyledInputMetter>{this.displayTextInputMetter()}</StyledInputMetter>
    )
  }
}

export default TextInputMetter



// WEBPACK FOOTER //
// ./src/presentations/elements/TextInputMetter/index.tsx